export const INIT = '__INIT__'
export const IN_CURRENCY_ACTION = 'IN_CURRENCY_ACTION'
export const OUT_CURRENCY_ACTION = 'OUT_CURRENCY_ACTION'
export const AMOUNT_ACTION = 'AMOUNT_ACTION'
export const SWAP_CURRENCY_ACTION = 'SWAP_CURRENCY_ACTION'
export const NEXT_SCREEN = 'NEXT_SCREEN'
export const BACK_SCREEN = 'BACK_SCREEN'
export const OUT_DESTINATION_ACTION = 'OUT_DESTINATION_ACTION'
export const CARD_NUMBER_ACTION = 'CARD_NUMBER_ACTION'
export const COMMENT_ACTION = 'COMMENT_ACTION'
export const PROVIDER_ACTION = 'PROVIDER_ACTION'
export const MIN_MAX_HALF_ACTION = 'MIN_MAX_HALF_ACTION'
export const IN_CURRENCY_SHOW_ACTION = 'IN_CURRENCY_SHOW_ACTION'
export const OUT_CURRENCY_SHOW_ACTION = 'OUT_CURRENCY_SHOW_ACTION'
export const OUT_DESTINATION_SHOW_ACTION = 'OUT_DESTINATION_SHOW_ACTION'
export const OUT_DESTINATION_TIME_ACTION = 'OUT_DESTINATION_TIME_ACTION'
export const ORDER_CREATED_ACTION = 'ORDER_CREATED_ACTION'
export const NOT_ACTIVE_IN_CURRENCY_ACTION = 'NOT_ACTIVE_IN_CURRENCY_ACTION'
export const NOT_ACTIVE_OUT_CURRENCY_ACTION = 'NOT_ACTIVE_OUT_CURRENCY_ACTION'
export const NEW_OUT_DESTINATION_ACTION = 'NEW_OUT_DESTINATION_ACTION'
export const VALIDATION_OUT_DESTINATION_ACTION = 'VALIDATION_OUT_DESTINATION_ACTION'
export const SEARCH_MODAL_IN_ACTION = 'SEARCH_MODAL_IN_ACTION'
export const SEARCH_MODAL_OUT_ACTION = 'SEARCH_MODAL_OUT_ACTION'
export const CURRENCY_ARRAY_ACTION = 'CURRENCY_ARRAY_ACTION'
export const MODAL_ERROR_ACTION = 'MODAL_ERROR_ACTION'
export const LOADER_ACTION = 'LOADER_ACTION'
export const FAIL_PROVIDERS = 'FAIL_PROVIDERS'
export const IN_CURRENCY_COIN = 'IN_CURRENCY_COIN'
export const OUT_CURRENCY_COIN = 'OUT_CURRENCY_COIN'
export const CLOSE_MODAL_ACTION = 'CLOSE_MODAL_ACTION'
export const RATE_PROVIDER_ACTION = 'RATE_PROVIDER_ACTION'
export const WALLET_NAME_ACTION = 'WALLET_NAME_ACTION'
export const LIMITS_ARRAY_ACTION = 'LIMITS_ARRAY_ACTION'
export const BACK_FIRST_SCREEN_ACTION = 'BACK_FIRST_SCREEN_ACTION'
export const ADVANCED_CLOSE_ACTION = 'ADVANCED_CLOSE_ACTION'
export const DESTINATION_TAG_ACTION = 'DESTINATION_TAG_ACTION'
export const CREATED_ORDER_ERROR = 'CREATED_ORDER_ERROR'
export const EXPIRATED_RATE = 'EXPIRATED_RATE'
export const ORDER_ACTION = 'ORDER_ACTION'

export const PAYWAY_ACTION = 'PAYWAY_ACTION'
export const LOADING_ACTION = 'LOADING_ACTION'
export const CARD_DATA = 'CARD_DATA'
export const CARD_COUNTRY_CODE = 'CARD_COUNTRY_CODE'
export const COUNTRY_SHOW = 'COUNTRY_SHOW'
export const ONE_TIME_CARD = 'ONE_TIME_CARD'
export const ADD_CARD = 'ADD_CARD'
export const SEARCH_MODAL_COUNTRY_ACTION = 'SEARCH_MODAL_COUNTRY_ACTION'
export const NEED_VERIFICATION = 'NEED_VERIFICATION'
export const SEARCH_MODAL_PAYWAY_ACTION = 'SEARCH_MODAL_PAYWAY_ACTION'
export const MOBILE_PHONE = 'MOBILE_PHONE'
export const MODAL_SERVER = 'MODAL_SERVER'
export const ACCOUNT_NUMBER_ACTION = 'ACCOUNT_NUMBER_ACTION'
export const EMAIL_ACTION = "EMAIL_ACTION"
export const MIN_MAX_ACTION = 'MIN_MAX_ACTION'
export const COMING_SOON_ACTION = 'COMING_SOON_ACTION'

export const COUNTED_FEES = 'COUNTED_FEES'
export const SKIP_PAYMENT_DETAILS = 'SKIP_PAYMENT_DETAILS'
export const CHECKED_ALMOST_ALL = 'CHECKED_ALMOST_ALL'

export const POST_MESSAGE_ERROR = 'POST_MESSAGE_ERROR'

export const BALANCE_HODL_MSG = 'BALANCE_HODL_MSG'

// ModalStore
export const SHOW_MODAL = 'SHOW_MODAL'
export const HIDE_MODAL = 'HIDE_MODAL'
export const FADE_TYPE = 'FADE_TYPE'

export const SCREEN_SHOW_MODAL = 'SCREEN_SHOW_MODAL'
export const SCREEN_HIDE_MODAL = 'SCREEN_HIDE_MODAL'